import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
// Global, not component-scoped: three lazily-loaded components share these modal
// styles (UrssafRegistrationModal, UrssafPaymentDemandModal, ErrorDialog), so
// importing it from each one left webpack unable to pick a single CSS order
// across chunk groups — a "Conflicting order" warning, fatal under CI=true.
// Loaded once here, its position is fixed for every chunk. It shares no selector
// with any other stylesheet, so entry-bundle placement changes no cascade.
import './features/urssaf/UrssafRegistrationModal.css';
import App from './App';
import { NotifyProvider } from './contexts/NotifyContext';
import { NetworkProvider } from './contexts/NetworkContext';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { initAnalytics } from './utils/analytics';
import { PublicOfferProvider } from './contexts/PublicOfferContext';
import { readPublicOfferSnapshot } from './utils/publicOffer';
import { captureFirstTouch } from './utils/attribution';

captureFirstTouch();
initAnalytics();
// Prerendered marketing pages (LAND3 R1): hydrate the static HTML; every other page renders.
const PRERENDER_MARKER = 'marketing';
const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <BrowserRouter basename="" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <NotifyProvider>
        <NetworkProvider>
          <PublicOfferProvider initialOffer={readPublicOfferSnapshot(document)}>
            <App />
          </PublicOfferProvider>
          <SpeedInsights />
        </NetworkProvider>
      </NotifyProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if (container.dataset.prerendered === PRERENDER_MARKER) {
  ReactDOM.hydrateRoot(container, tree, {
    // eslint-disable-next-line no-console
    onRecoverableError: (error) => console.warn('Hydration mismatch:', error),
  });
} else {
  ReactDOM.createRoot(container).render(tree);
}
